// Do NOT add "use client" to this file
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
export var ProductName = function(param) {
    var productName = param.productName;
    return /*#__PURE__*/ _jsx("div", {
        className: "mb-1 max-w-full",
        children: /*#__PURE__*/ _jsx(Typography, {
            className: "line-clamp-2 whitespace-normal break-words",
            variant: "paragraphSansMedium",
            "data-test-id": "product-tile-product-name",
            children: productName
        })
    });
};
